import PropTypes from 'prop-types'
import React from 'react'
import SidebarWidget from './SidebarWidget'
import styles from './_sidebarWidget.css'
import * as premium from 'services/premium/selectors'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import Button from 'components/util/Button'
import { getMVPUrl } from 'shared/urls'

const mapStateToProps = (state) => ({
  isPremium: premium.selectIsPremium(state),
})

function ExportWorkoutHistory ({ isPremium }) {
  return (
    <SidebarWidget>
      <h3>
        <FormattedMessage
          id='workouts.lifetimestats.sidebar.title'
          defaultMessage='Export workout history' />
      </h3>
      <div>
        <FormattedMessage
          id='workouts.lifetimestats.sidebar.body'
          defaultMessage='MVP users can export their entire workout history' />
      </div>
      <div className={styles.csvDownloadLink}>
        {isPremium ?
          <a href='/workout/export/csv' target='_blank' rel='noopener noreferrer'>
            <FormattedMessage
              id='workouts.lifetimestats.sidebar.export'
              defaultMessage='Export as CSV' />
          </a>
      :
        <a className={styles.buttonLink} href={getMVPUrl(window)}>
          <Button el='button' type='action'>
            <FormattedMessage
              id='workouts.lifetimestats.sidebar.gomvp'
              defaultMessage='Go MVP'
            />
          </Button>
        </a>}
      </div>
    </SidebarWidget>
  )
}

ExportWorkoutHistory.propTypes = {
  isPremium: PropTypes.bool,
}

export default connect(mapStateToProps)(ExportWorkoutHistory)
